import "./EditVideoProperties/EditVideoPropertiesComponent";
import "./VideoProperties.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import VideoPropertiesComponentController from "./VideoPropertiesComponentController";

export default class VideoPropertiesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentFunctionalityType: "<",
        };
        this.controller = VideoPropertiesComponentController;
        this.templateUrl = "/App/Components/EquipmentFunctionalityType/VideoProperties/VideoProperties.html";
    }
}

module("mmManagePortal").component("irFunctionalityVideoProperties", new VideoPropertiesComponent());
